import { MarkdownReference } from '@/components/editor/extractMarkdownReferences';
import { TicketStore } from '@/components/editor/TicketPlugin/TicketPlugin';
import { EventMeta, User } from '@certhon/models';

export function markdownReferencesToMeta(
  references: MarkdownReference[],
  userMap: Map<string | number, User>,
  ticketStore: TicketStore,
): EventMeta | undefined {
  if (!references.length) return undefined;

  const referencedTicketIds: string[] = [];
  const referencedUserIds: number[] = [];

  const users = Array.from(userMap.values());

  for (const ref of references) {
    if (ref.type === 'ticket') {
      const ticket = ticketStore.getTicket(ref.ticketId);
      if (ticket) {
        referencedTicketIds.push(ticket.id);
      } else if (
        // TODO: todo use isUUID util
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
          ref.ticketId,
        )
      ) {
        referencedTicketIds.push(ref.ticketId);
      }
    } else if (ref.type === 'mention') {
      const usernameLower = ref.username.toLowerCase();
      const user = users.find(
        (u) =>
          u.loginname?.toLowerCase() === usernameLower ||
          u.name?.toLowerCase() === usernameLower,
      );
      if (user) {
        referencedUserIds.push(user.recnum);
      }
    }
  }

  const uniqueTicketIds = Array.from(new Set(referencedTicketIds));
  const uniqueUserIds = Array.from(new Set(referencedUserIds));

  if (!uniqueTicketIds.length && !uniqueUserIds.length) return undefined;

  const meta: EventMeta = {};
  if (uniqueTicketIds.length) meta.referencedTicketIds = uniqueTicketIds;
  if (uniqueUserIds.length) meta.referencedUserIds = uniqueUserIds;
  return meta;
}
